export default __webpack_public_path__ + "static/jase_avatar-d4666bcd4629b13233a02794851bd1c6.png";